export default __webpack_public_path__ + "static/media/PASSING TRAINING SETUP.d9ebd618.png";